module.exports = __webpack_public_path__ + "static/media/img_Inscription_name2.b084d4f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_Inscription_name2.png
// module id = 992
// module chunks = 0